import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SiteConfigStore } from '@program-suite/data-common';
import { ButtonComponent } from '@program-suite/ui';

@Component({
  selector: 'lib-branding',
  imports: [CommonModule, ButtonComponent],
  templateUrl: './branding.component.html',
  styleUrls: ['./branding.component.scss', '../admin-settings.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BrandingComponent {
  siteConfigStore = inject(SiteConfigStore);
  siteUrl = window.location.origin;

  getFileName(url: string | undefined | null): string {
    if (!url) return '';
    const parts = url.split(/[/\\]/);
    return parts.pop() || '';
  }

  copyToClipboard(): void {
    navigator.clipboard.writeText(this.siteUrl);
  }
}
